import React from "react";
import { Route, Routes } from "react-router-dom";
import { DashboardLayout } from "./DashboardLayout";
import DashboardPage from "../pages/dashboard/dashboardPage";
import PolicyDetailPage from "../pages/policy/PolicyDetailPage";
import Settings from "../pages/settings/Settings";
import ProfilePage from "../pages/dashboard/ProfilePage";
import TransactionsPage from "../pages/dashboard/TransactionsPage";
import InsurePage from "../pages/dashboard/InsurePage";
import MaxInvestmentsPage from "../pages/dashboard/MaxInvestmentsPage";
import RetailLifePage from "../pages/dashboard/RetailLifePage";
import ProductsPage from "../pages/dashboard/ProductsPage";
import LifePage from "../pages/dashboard/LifePage"; 
import PensionsPage from "../pages/dashboard/PensionsPage"; 
import CorporatesPage from "../pages/dashboard/CorporatePage";
import Transactions from "../pages/dashboard/Transactions";
import TransactionsCorporatePage from "../pages/dashboard/TransactionCorporatePage";  
import TransactionsLifePage from "../pages/dashboard/TransactionsLifePage";
import TransactionsPensionPage from "../pages/dashboard/TransactionsPensionsPage"; // Ensure this import is correct
import LifeProductDetails from "../pages/dashboard/LifeProductDetails";
import PensionsProductDetails from "../pages/dashboard/PensionsProductDetails";
import CorporateProductDetails from "../pages/dashboard/CorporateProductDetails"; 
import Feedback from "../pages/dashboard/Feedback";

import UnpaidPremiums from "../pages/dashboard/UnpaidPremiums";
import SelectPaymentMethod from "../pages/dashboard/SelectPaymentMethod";
import Summary from "../pages/dashboard/Summary";
import NotificationsPage from "../pages/dashboard/NotificationsPage";
import PaymentSuccess from "../pages/payment/PaymentSuccess";
import PaymentCancel from "../pages/payment/PaymentCancel";

export const AuthenticatedRoutes = () => {
  const hideCorporate = process.env.REACT_APP_HIDE_CORPORATE === 'true';
  
  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/transactions-history" element={<TransactionsPage />} />
        {!hideCorporate && <Route path="/transactions/corporate" element={<TransactionsCorporatePage />} />}
        <Route path="/transactions/life" element={<TransactionsLifePage />} />
        <Route path="/transactions/pension" element={<TransactionsPensionPage />} />  
        <Route path="/policy/:policyId" element={<PolicyDetailPage />} />
        <Route path="/insure" element={<InsurePage />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/life-product-details" element={<LifeProductDetails />} />
        <Route path="/pensions-product-details" element={<PensionsProductDetails/>} />
        {!hideCorporate && <Route path="/corporate-product-details" element={<CorporateProductDetails />} />}
        <Route path="/pay-unpaid-premiums" element={<UnpaidPremiums />} />
        <Route path="/select-payment-method" element={<SelectPaymentMethod />} />
        <Route path="/summary" element={<Summary />} />
        
        {/* Payment callback routes from Hubtel */}
        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/cancel" element={<PaymentCancel />} />

        {/* Transaction History and Statement Routes for each product type */}
        <Route path="/pension/transactions" element={React.createElement(require('../pages/pension/PensionTransactionsHistory.jsx').default)} />
        <Route path="/pension/statement" element={React.createElement(require('../pages/pension/PensionTransactionStatement.jsx').default)} />
        <Route path="/life/transactions" element={React.createElement(require('../pages/life/LifeTransactionsHistory.jsx').default)} />
        <Route path="/lifepage/transactions" element={React.createElement(require('../pages/dashboard/TransactionsLifePage.jsx').default)} />
        <Route path="/pensionpage/transactions" element={React.createElement(require('../pages/dashboard/TransactionsPensionsPage.jsx').default)} />
        <Route path="/life/statement" element={React.createElement(require('../pages/life/LifeTransactionStatement.jsx').default)} />
        {!hideCorporate && <Route path="/corporate/transactions" element={React.createElement(require('../pages/corporate/CorporateTransactionsHistory.jsx').default)} />}
        {!hideCorporate && <Route path="/corporate/statement" element={React.createElement(require('../pages/corporate/CorporateTransactionStatement.jsx').default)} />}

        <Route path="/products" element={<ProductsPage />} />
        <Route path="/pension-life" element={<MaxInvestmentsPage />} />
        <Route path="/pension-pension" element={<RetailLifePage />} />
        {!hideCorporate && <Route path="/corporate" element={<CorporatesPage />} />}
        <Route path="/life" element={<LifePage />} />
        <Route path="/pension" element={<PensionsPage />} /> 
      </Routes>
    </DashboardLayout>
  );
};